/** @format */

import { TFleet } from "../declarations/maps/fleets";
import { TStore } from "../declarations/store";

export const selectorFleetList = (store: TStore): TFleet[] => store.fleets.fleetList || [];

export const selectorFleet = (store: TStore, id: string): TFleet | undefined =>
  store.fleets.fleetList?.find(fleet => fleet.id === id) || undefined;
